// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__GrUtG","rotation":"Loader_rotation__PINnv","center":"Loader_center__XBWo2"};